import { DEFAULT_HUBSPOT_MEETING_LINK } from '@Saral-Influencer-Marketing/saral-utils/dist/constants/hubspot';
import { APPLICATION_FORM_APPROVAL_PREFERENCES } from '@Saral-Influencer-Marketing/saral-utils/src/constants/inboundForm';

import { contractTemplateType } from '@/components/Dashboard/Lists/components/ContractsBox/NewContractModal/SelectContractTemplate/SelectContractTemplate';

export const ambassadorSaralEmail = 'ambassadors@trysaral.com';
export const campaignStatusStart = 'START';
export const campaignStatusPause = 'PAUSED';
export const dripDefaultEmail1 = `<div>Hey {{first_name}},</div><div><br></div><div>Recently came across your profile, loving your content &amp; vibe! I’m reaching out as the JOB_TITLE at BRAND because we’d like to strike up a partnership.</div><div><br></div><div>ADD_INFO_ABOUT_BRAND. Your content fits well with what we’re doing with our new ambassador program. My goal is to work with you long-term as I feel you truly align with our brand values. I can send you a free product before you say yes to anything 🙂</div><div><br></div><div>We're looking at sharing PERCENTAGE% for every sale you drive. I'll also setup some perks for your audience. It would be cool to work together! </div><div><br></div><div>Would you be interested?</div><div><br></div><div>--</div><div>{{your_name}}</div>`;
export const dripDefaultEmail2 = `<div>Hi again {{first_name}} - quick bump here in case you missed my last email.</div><div><br></div><div>Would you be interested in a collaboration with us?</div>`;
export const dripDefaultEmail3 = `<div>{{first_name}} - we’re accepting only 25 creators this quarter to work closely with. I really like your vibe so following up. We can discuss the terms if what I sent isn’t exactly a fit.</div><div><br></div><div>Are you open to collabs with brands?</div><div><br></div><div>PS: Let me know if now isn’t the right time and I’ll stop bugging you!</div>`;
export const dripDefaultEmail4 = `<div>Hi {{first_name}},</div><div><br></div><div>Since I have not received a reply for the last few times I'm gonna assume one of two things:</div><div><br></div><div>1. Now is not the right time for us to work together.</div><div>2. I've annoyed the hell out of you and you want to fire me now!!</div><div><br></div><div>1 or 2?</div>`;
export const shippingForShopifyErrorMessage = 'Shipping is currently only for Shopify stores';
export const masterLoginPassword = '$t+bj-=QaDzz6qQ-9R75P6$jUrJr5Ypt';
export const customTagStringRegex = new RegExp(/^[A-Za-z0-9\-_]+$/);
export const saralPurple = '#7357e9';
export const STAGE_ADDED_BY_SYSTEM = 'system';
export const STAGE_ADDED_BY_USER = 'user';
export const ageFilterSliderMarks = [
  { value: 16, label: '16' },
  { value: 18, label: '' },
  { value: 25, label: '' },
  { value: 30, label: '' },
  { value: 35, label: '' },
  { value: 40, label: '' },
  { value: 45, label: '' },
  { value: 50, label: '' },
  { value: 55, label: '' },
  { value: 60, label: '' },
  { value: 65, label: '65+' },
];
export const applicationFetchLimit = 10;
export const blacklistFetchLimit = 8;
export const saralNewPurple = '#7E38E8';

export const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

export const HELP_DESK_ARTICLES = {
  ProductSeedingFunnel:
    'https://help.getsaral.com/en/articles/188-how-do-i-read-and-understand-the-seeding-funnel-data',
  PeopleReached: 'https://help.getsaral.com/en/articles/206-performance-metrics-overview',
  HowToSetupGoogleOauthForSaral: 'https://help.getsaral.com/en/articles/289-how-to-set-up-gmail-oauth-for-saral',
};

export const INBOUND_TABLE_DUMMY_DATA = [
  {
    email: 'wade.warren@gmail.com',
    approvalStatus: 'pending',
    ambassadorProgramQuestions: [
      {
        q: 'How many followers do you have?',
        a: '15000',
        _id: {
          $oid: '65943803c40788870e2a3d0a',
        },
      },
    ],
    createdAt: '2024-02-23T16:21:09.579Z',
    address: {
      addressLineOne: '',
      addressLineTwo: '',
      pincode: '10001',
      city: 'Portland',
      state: 'OR',
      country: 'United States',
      phone: '',
    },
    firstName: 'Wade',
    lastName: 'Warren',
    imgUrl: 'https://influencer-profile-image-new.s3.amazonaws.com/Ellipse+27.png',
  },
  {
    email: 'brooklyn.simmons@company.com',
    approvalStatus: 'pending',
    ambassadorProgramQuestions: [
      {
        q: 'How many followers do you have?',
        a: '12000000',
        _id: {
          $oid: '659437ddc40788870e2a3cd5',
        },
      },
    ],
    createdAt: '2024-02-14T16:20:31.354Z',

    address: {
      addressLineOne: '',
      addressLineTwo: '',
      pincode: '10001',
      city: 'Detroit',
      state: 'MI',
      country: 'United States',
      phone: '',
    },
    firstName: 'Brooklyn',
    lastName: 'Simmons',
    imgUrl: 'https://influencer-profile-image-new.s3.amazonaws.com/Ellipse+28.png',
  },
  {
    email: 'jerome.bell@gmail.com',
    approvalStatus: 'pending',
    ambassadorProgramQuestions: [
      {
        q: 'How many followers do you have?',
        a: '10000',
        _id: {
          $oid: '659437bb322e9c046b7e0ce6',
        },
      },
    ],
    createdAt: '2024-02-03T16:19:58.807Z',
    address: {
      addressLineOne: '',
      addressLineTwo: '',
      pincode: '',
      city: 'Los Angeles',
      state: 'CA',
      country: 'United States',
      phone: '',
    },
    firstName: 'Jerome',
    lastName: 'Bell',
    imgUrl: 'https://influencer-profile-image-new.s3.amazonaws.com/Ellipse+29.png',
  },
  {
    email: 'floyd@gmail.com',
    approvalStatus: 'pending',
    ambassadorProgramQuestions: [
      {
        q: 'How many followers do you have?',
        a: '200000',
        _id: {
          $oid: '659437a3322e9c046b7e0cd1',
        },
      },
    ],
    createdAt: '2024-02-10T16:19:33.678Z',

    address: {
      addressLineOne: '',
      addressLineTwo: '',
      pincode: '',
      city: 'Columbus',
      state: 'OH',
      country: 'United States',
      phone: '',
    },
    firstName: 'Floyd',
    lastName: 'Miles',
    imgUrl: 'https://influencer-profile-image-new.s3.amazonaws.com/Ellipse+30.png',
  },
  {
    email: 'annette.black@gmail.com',
    approvalStatus: 'pending',
    ambassadorProgramQuestions: [
      {
        q: 'How many followers do you have?',
        a: '25000',
        _id: {
          $oid: '6594378b322e9c046b7e0cbb',
        },
      },
    ],
    createdAt: '2024-02-21T16:19:00.884Z',
    address: {
      addressLineOne: '',
      addressLineTwo: '',
      pincode: '',
      city: 'Charlotte',
      state: 'NC',
      country: 'United States',
      phone: '',
    },
    firstName: 'Annette',
    lastName: 'Black',
    imgUrl: 'https://influencer-profile-image-new.s3.amazonaws.com/Ellipse+31.png',
  },
];

export const languageSelectOptions = [
  { label: 'Default (🇺🇸 English)', value: 'english' },
  { label: '🇫🇷 French', value: 'french' },
  { label: '🇩🇪 German', value: 'german' },
  { label: '🇪🇸 Spanish', value: 'spanish' },
  { label: '🇮🇹 Italian', value: 'italian' },
];

const googleFonts = ['Poppins', 'Roboto', 'Open Sans', 'Montserrat', 'Raleway'];

const defaultFontSize = '20px'; // Define a default font size here

export const fontSelectOptions = googleFonts.map((font) => {
  const formattedFont = font.replace(/\s+/g, '-'); // Format the font name for value
  return {
    font: font,
    size: defaultFontSize, // Adjust size based on font if needed
    value: formattedFont,
    label: font,
  };
});

export const LocalStorageSidebarKey = 'sidebar-expanded';

export const dummyStatsData = {
  totalPosts: 141,
  contentValue: 550000,
  impressions: 130000,
  emv: 430000,
  postsPerCreator: 3,
  cpm: 32,
  likes: 80000,
  comments: 232,
  cpe: 32,
  cpc: 45,
  commentSentiment: {
    buying: 25.62,
    negative: 24.05,
    neutral: 50.33,
  },
};

export const dummyPostsData = [
  {
    _id: '65c0c83d2d058505447d',
    type: 'post',
    images: [
      {
        url: 'https://saral-docs-dev.s3.ap-south-1.amazonaws.com/b4511020cd81fb02aaaf9fa4a24e5101.jpeg',
      },
      {
        url: 'https://saral-docs-dev.s3.ap-south-1.amazonaws.com/efb0ff8932a139f60e9ca7ddcc35f771.jpeg',
      },
    ],
    video: '',
    entityUrl: 'https://instagram.com/p/C2uYJocoqz_',
    creativeCreatedDate: '2024-02-05T11:36:29.773Z',
    media: [
      {
        url: 'https://saral-docs-dev.s3.ap-south-1.amazonaws.com/b4511020cd81fb02aaaf9fa4a24e5101.jpeg',
      },
      {
        url: 'https://saral-docs-dev.s3.ap-south-1.amazonaws.com/efb0ff8932a139f60e9ca7ddcc35f771.jpeg',
      },
    ],
    likes: 89,
    comments: 32,
    shares: null,
    saves: null,
    impressions: 102.2,
    engagementRate: 17.416829745596868,
    contentValue: 100,
    sentiment: 'Positive',
    caption: 'Some more pics from @getsaral recent offsite trip :)',
    profile: {
      imageUrl: 'https://influencer-profile-image.s3.ap-south-1.amazonaws.com/getalmund-8qa7r.jpg',
      username: 'getalmund',
      platform: 'instagram',
      followers: 347,
    },
  },
  {
    _id: '65c33e1c78940f72036b4',
    type: 'reel',
    images: '',
    video: [
      {
        url: 'https://geekshubh-sst-lambdas-pos-posttrackingmediabucket6-ediggjz6kjt3.s3.ap-south-1.amazonaws.com/getalmund-20jtc.mp4?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIA6HJRT6FCTJKVWOSB%2F20240207%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20240207T184002Z&X-Amz-Expires=3600&X-Amz-Signature=0cd067eaf0ad76456620882f51ce00ca38d39ab1045c34409e375c0cbd4f66dc&X-Amz-SignedHeaders=host',
      },
    ],
    entityUrl: 'https://instagram.com/p/Czhlc5EPj4Z',
    creativeCreatedDate: '2023-11-11T23:49:32.000Z',
    media: [
      {
        url: 'https://geekshubh-sst-lambdas-pos-posttrackingmediabucket6-ediggjz6kjt3.s3.ap-south-1.amazonaws.com/getalmund-20jtc.mp4?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIA6HJRT6FCTJKVWOSB%2F20240207%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20240207T184002Z&X-Amz-Expires=3600&X-Amz-Signature=0cd067eaf0ad76456620882f51ce00ca38d39ab1045c34409e375c0cbd4f66dc&X-Amz-SignedHeaders=host',
      },
    ],
    likes: 2,
    comments: 0,
    shares: null,
    saves: null,
    impressions: 69.4,
    engagementRate: 0.5763688760806917,
    contentValue: 100,
    sentiment: 'Neutral',
    caption:
      'Unlock the secrets to driving online business traffic! 🚀 Tune in to our podcast with Yash Chavan, CEO of Saral, the visionary behind an innovative Influencer Relationship Management platform. 🎧🌟\n\n🔍 Discover the secrets to winning brand partnerships and how to become the influencer they can’t resist! 💥💰\n\nSubscribe to our E-Commerce Newsletter for proven strategies, the latest DTC trends, and insights. Join our community of 35,000+ marketers. Click the link in our bio. 🚀\n\n#saral #InfluencerMarketing #BrandCollaborations #EngageAuthentically #ModernInfluencers #ReelRevelations #podcast #htepodcast #saral #yash # brand #influncer #momentmarketing #memesdaily #funnymemes #socialmedia #agencylife  #creativespot #madovermarketing #contentmarketing #marketingdigital #marketingtips #branding #marketingmeme #marketingagency #onlinemarketing #memestagram #memetemplate',
    profile: {
      imageUrl: 'https://influencer-profile-image.s3.ap-south-1.amazonaws.com/getalmund-8qa7r.jpg',
      username: 'getalmund',
      platform: 'instagram',
      followers: 347,
    },
  },
  {
    _id: '65c0c83dss2d058505447d',
    type: 'post',
    images: [
      {
        url: 'https://saral-docs-dev.s3.ap-south-1.amazonaws.com/b4511020cd81fb02aaaf9fa4a24e5101.jpeg',
      },
      {
        url: 'https://saral-docs-dev.s3.ap-south-1.amazonaws.com/efb0ff8932a139f60e9ca7ddcc35f771.jpeg',
      },
    ],
    video: '',
    entityUrl: 'https://instagram.com/p/C2uYJocoqz_',
    creativeCreatedDate: '2024-02-05T11:36:29.773Z',
    media: [
      {
        url: 'https://saral-docs-dev.s3.ap-south-1.amazonaws.com/b4511020cd81fb02aaaf9fa4a24e5101.jpeg',
      },
      {
        url: 'https://saral-docs-dev.s3.ap-south-1.amazonaws.com/efb0ff8932a139f60e9ca7ddcc35f771.jpeg',
      },
    ],
    likes: 89,
    comments: 32,
    shares: null,
    saves: null,
    impressions: 102.2,
    engagementRate: 17.416829745596868,
    contentValue: 100,
    sentiment: 'Positive',
    caption: 'Some more pics from @getsaral recent offsite trip :)',
    profile: {
      imageUrl: 'https://influencer-profile-image.s3.ap-south-1.amazonaws.com/getalmund-8qa7r.jpg',
      username: 'getalmund',
      platform: 'instagram',
      followers: 347,
    },
  },
  {
    _id: '6513be1c78940f72036ba',
    type: 'reel',
    images: '',
    video: [
      {
        url: 'https://saral-docs-dev.s3.ap-south-1.amazonaws.com/getalmund-20jtc+(1).mp4',
      },
    ],
    entityUrl: 'https://instagram.com/p/Cy-ykrbogCu',
    creativeCreatedDate: '2023-10-29T11:31:08.000Z',
    media: [
      {
        url: 'https://saral-docs-dev.s3.ap-south-1.amazonaws.com/getalmund-20jtc+(1).mp4',
      },
    ],
    likes: 8,
    comments: 2,
    shares: null,
    saves: null,
    impressions: 69.4,
    engagementRate: 2.3054755043227666,
    contentValue: 100,
    sentiment: 'Positive',
    caption:
      'Yash Chavan, CEO of Saral, a dynamic Influencer Relationship Management platform, reveals big brands are searching for a new breed of influencers who can authentically connect with their audience, drive real engagement, and embody their brand values. In this reel, let’s spill the tea ☕ on what big brands crave from influencers nowadays! 💼🌟\n\n🔍 Discover the secrets to winning brand partnerships and how to become the influencer they can’t resist! 💥💰\n\nSubscribe to our E-Commerce Newsletter for proven strategies, the latest DTC trends, and insights. Join our community of 35,000+ marketers. Click the link in our bio. 🚀\n\n#saral #InfluencerMarketing #BrandCollaborations #EngageAuthentically #ModernInfluencers #ReelRevelations #podcast #htepodcast #saral #yash # brand #influncer #momentmarketing #memesdaily #funnymemes #socialmedia #agencylife  #creativespot #madovermarketing #contentmarketing #marketingdigital #marketingtips #branding #marketingmeme #marketingagency #onlinemarketing #memestagram #memetemplate',
    profile: {
      imageUrl: 'https://influencer-profile-image.s3.ap-south-1.amazonaws.com/getalmund-8qa7r.jpg',
      username: 'getalmund',
      platform: 'instagram',
      followers: 347,
    },
  },
  {
    _id: '65c0c83d2d05850544c56',
    type: 'post',
    images: [
      {
        url: 'https://saral-docs-dev.s3.ap-south-1.amazonaws.com/b4511020cd81fb02aaaf9fa4a24e5101.jpeg',
      },
      {
        url: 'https://saral-docs-dev.s3.ap-south-1.amazonaws.com/efb0ff8932a139f60e9ca7ddcc35f771.jpeg',
      },
    ],
    video: '',
    entityUrl: 'https://instagram.com/p/C2uYJocoqz_',
    creativeCreatedDate: '2024-02-05T11:36:29.773Z',
    media: [
      {
        url: 'https://saral-docs-dev.s3.ap-south-1.amazonaws.com/b4511020cd81fb02aaaf9fa4a24e5101.jpeg',
      },
      {
        url: 'https://saral-docs-dev.s3.ap-south-1.amazonaws.com/efb0ff8932a139f60e9ca7ddcc35f771.jpeg',
      },
    ],
    likes: 89,
    comments: 32,
    shares: null,
    saves: null,
    impressions: 102.2,
    engagementRate: 17.416829745596868,
    contentValue: 100,
    sentiment: 'Positive',
    caption: 'Some more pics from @getsaral recent offsite trip :)',
    profile: {
      imageUrl: 'https://influencer-profile-image.s3.ap-south-1.amazonaws.com/getalmund-8qa7r.jpg',
      username: 'getalmund',
      platform: 'instagram',
      followers: 347,
    },
  },
  {
    _id: '65c1d1338940f72036b4',
    type: 'reel',
    images: '',
    video: [
      {
        url: 'https://geekshubh-sst-lambdas-pos-posttrackingmediabucket6-ediggjz6kjt3.s3.ap-south-1.amazonaws.com/getalmund-20jtc.mp4?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIA6HJRT6FCTJKVWOSB%2F20240207%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20240207T184002Z&X-Amz-Expires=3600&X-Amz-Signature=0cd067eaf0ad76456620882f51ce00ca38d39ab1045c34409e375c0cbd4f66dc&X-Amz-SignedHeaders=host',
      },
    ],
    entityUrl: 'https://instagram.com/p/Czhlc5EPj4Z',
    creativeCreatedDate: '2023-11-11T23:49:32.000Z',
    media: [
      {
        url: 'https://geekshubh-sst-lambdas-pos-posttrackingmediabucket6-ediggjz6kjt3.s3.ap-south-1.amazonaws.com/getalmund-20jtc.mp4?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIA6HJRT6FCTJKVWOSB%2F20240207%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20240207T184002Z&X-Amz-Expires=3600&X-Amz-Signature=0cd067eaf0ad76456620882f51ce00ca38d39ab1045c34409e375c0cbd4f66dc&X-Amz-SignedHeaders=host',
      },
    ],
    likes: 2,
    comments: 0,
    shares: null,
    saves: null,
    impressions: 69.4,
    engagementRate: 0.5763688760806917,
    contentValue: 100,
    sentiment: 'Neutral',
    caption:
      'Unlock the secrets to driving online business traffic! 🚀 Tune in to our podcast with Yash Chavan, CEO of Saral, the visionary behind an innovative Influencer Relationship Management platform. 🎧🌟\n\n🔍 Discover the secrets to winning brand partnerships and how to become the influencer they can’t resist! 💥💰\n\nSubscribe to our E-Commerce Newsletter for proven strategies, the latest DTC trends, and insights. Join our community of 35,000+ marketers. Click the link in our bio. 🚀\n\n#saral #InfluencerMarketing #BrandCollaborations #EngageAuthentically #ModernInfluencers #ReelRevelations #podcast #htepodcast #saral #yash # brand #influncer #momentmarketing #memesdaily #funnymemes #socialmedia #agencylife  #creativespot #madovermarketing #contentmarketing #marketingdigital #marketingtips #branding #marketingmeme #marketingagency #onlinemarketing #memestagram #memetemplate',
    profile: {
      imageUrl: 'https://influencer-profile-image.s3.ap-south-1.amazonaws.com/getalmund-8qa7r.jpg',
      username: 'getalmund',
      platform: 'instagram',
      followers: 347,
    },
  },
  {
    _id: 'c0c83d2d058505447d4c56',
    type: 'post',
    images: [
      {
        url: 'https://saral-docs-dev.s3.ap-south-1.amazonaws.com/b4511020cd81fb02aaaf9fa4a24e5101.jpeg',
      },
      {
        url: 'https://saral-docs-dev.s3.ap-south-1.amazonaws.com/efb0ff8932a139f60e9ca7ddcc35f771.jpeg',
      },
    ],
    video: '',
    entityUrl: 'https://instagram.com/p/C2uYJocoqz_',
    creativeCreatedDate: '2024-02-05T11:36:29.773Z',
    media: [
      {
        url: 'https://saral-docs-dev.s3.ap-south-1.amazonaws.com/b4511020cd81fb02aaaf9fa4a24e5101.jpeg',
      },
      {
        url: 'https://saral-docs-dev.s3.ap-south-1.amazonaws.com/efb0ff8932a139f60e9ca7ddcc35f771.jpeg',
      },
    ],
    likes: 89,
    comments: 32,
    shares: null,
    saves: null,
    impressions: 102.2,
    engagementRate: 17.416829745596868,
    contentValue: 100,
    sentiment: 'Positive',
    caption: 'Some more pics from @getsaral recent offsite trip :)',
    profile: {
      imageUrl: 'https://influencer-profile-image.s3.ap-south-1.amazonaws.com/getalmund-8qa7r.jpg',
      username: 'getalmund',
      platform: 'instagram',
      followers: 347,
    },
  },
  {
    _id: '65c1d133e1c7894036b4',
    type: 'reel',
    images: '',
    video: [
      {
        url: 'https://geekshubh-sst-lambdas-pos-posttrackingmediabucket6-ediggjz6kjt3.s3.ap-south-1.amazonaws.com/getalmund-20jtc.mp4?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIA6HJRT6FCTJKVWOSB%2F20240207%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20240207T184002Z&X-Amz-Expires=3600&X-Amz-Signature=0cd067eaf0ad76456620882f51ce00ca38d39ab1045c34409e375c0cbd4f66dc&X-Amz-SignedHeaders=host',
      },
    ],
    entityUrl: 'https://instagram.com/p/Czhlc5EPj4Z',
    creativeCreatedDate: '2023-11-11T23:49:32.000Z',
    media: [
      {
        url: 'https://geekshubh-sst-lambdas-pos-posttrackingmediabucket6-ediggjz6kjt3.s3.ap-south-1.amazonaws.com/getalmund-20jtc.mp4?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIA6HJRT6FCTJKVWOSB%2F20240207%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20240207T184002Z&X-Amz-Expires=3600&X-Amz-Signature=0cd067eaf0ad76456620882f51ce00ca38d39ab1045c34409e375c0cbd4f66dc&X-Amz-SignedHeaders=host',
      },
    ],
    likes: 2,
    comments: 0,
    shares: null,
    saves: null,
    impressions: 69.4,
    engagementRate: 0.5763688760806917,
    contentValue: 100,
    sentiment: 'Neutral',
    caption:
      'Unlock the secrets to driving online business traffic! 🚀 Tune in to our podcast with Yash Chavan, CEO of Saral, the visionary behind an innovative Influencer Relationship Management platform. 🎧🌟\n\n🔍 Discover the secrets to winning brand partnerships and how to become the influencer they can’t resist! 💥💰\n\nSubscribe to our E-Commerce Newsletter for proven strategies, the latest DTC trends, and insights. Join our community of 35,000+ marketers. Click the link in our bio. 🚀\n\n#saral #InfluencerMarketing #BrandCollaborations #EngageAuthentically #ModernInfluencers #ReelRevelations #podcast #htepodcast #saral #yash # brand #influncer #momentmarketing #memesdaily #funnymemes #socialmedia #agencylife  #creativespot #madovermarketing #contentmarketing #marketingdigital #marketingtips #branding #marketingmeme #marketingagency #onlinemarketing #memestagram #memetemplate',
    profile: {
      imageUrl: 'https://influencer-profile-image.s3.ap-south-1.amazonaws.com/getalmund-8qa7r.jpg',
      username: 'getalmund',
      platform: 'instagram',
      followers: 347,
    },
  },
  {
    _id: '65c1d1378940f72036ba',
    type: 'reel',
    images: '',
    video: [
      {
        url: 'https://saral-docs-dev.s3.ap-south-1.amazonaws.com/getalmund-20jtc+(1).mp4',
      },
    ],
    entityUrl: 'https://instagram.com/p/Cy-ykrbogCu',
    creativeCreatedDate: '2023-10-29T11:31:08.000Z',
    media: [
      {
        url: 'https://saral-docs-dev.s3.ap-south-1.amazonaws.com/getalmund-20jtc+(1).mp4',
      },
    ],
    likes: 8,
    comments: 2,
    shares: null,
    saves: null,
    impressions: 69.4,
    engagementRate: 2.3054755043227666,
    contentValue: 100,
    sentiment: 'Positive',
    caption:
      'Yash Chavan, CEO of Saral, a dynamic Influencer Relationship Management platform, reveals big brands are searching for a new breed of influencers who can authentically connect with their audience, drive real engagement, and embody their brand values. In this reel, let’s spill the tea ☕ on what big brands crave from influencers nowadays! 💼🌟\n\n🔍 Discover the secrets to winning brand partnerships and how to become the influencer they can’t resist! 💥💰\n\nSubscribe to our E-Commerce Newsletter for proven strategies, the latest DTC trends, and insights. Join our community of 35,000+ marketers. Click the link in our bio. 🚀\n\n#saral #InfluencerMarketing #BrandCollaborations #EngageAuthentically #ModernInfluencers #ReelRevelations #podcast #htepodcast #saral #yash # brand #influncer #momentmarketing #memesdaily #funnymemes #socialmedia #agencylife  #creativespot #madovermarketing #contentmarketing #marketingdigital #marketingtips #branding #marketingmeme #marketingagency #onlinemarketing #memestagram #memetemplate',
    profile: {
      imageUrl: 'https://influencer-profile-image.s3.ap-south-1.amazonaws.com/getalmund-8qa7r.jpg',
      username: 'getalmund',
      platform: 'instagram',
      followers: 347,
    },
  },
  {
    _id: '65ce1c78940f72036ba',
    type: 'reel',
    images: '',
    video: [
      {
        url: 'https://saral-docs-dev.s3.ap-south-1.amazonaws.com/getalmund-20jtc+(1).mp4',
      },
    ],
    entityUrl: 'https://instagram.com/p/Cy-ykrbogCu',
    creativeCreatedDate: '2023-10-29T11:31:08.000Z',
    media: [
      {
        url: 'https://saral-docs-dev.s3.ap-south-1.amazonaws.com/getalmund-20jtc+(1).mp4',
      },
    ],
    likes: 8,
    comments: 2,
    shares: null,
    saves: null,
    impressions: 69.4,
    engagementRate: 2.3054755043227666,
    contentValue: 100,
    sentiment: 'Positive',
    caption:
      'Yash Chavan, CEO of Saral, a dynamic Influencer Relationship Management platform, reveals big brands are searching for a new breed of influencers who can authentically connect with their audience, drive real engagement, and embody their brand values. In this reel, let’s spill the tea ☕ on what big brands crave from influencers nowadays! 💼🌟\n\n🔍 Discover the secrets to winning brand partnerships and how to become the influencer they can’t resist! 💥💰\n\nSubscribe to our E-Commerce Newsletter for proven strategies, the latest DTC trends, and insights. Join our community of 35,000+ marketers. Click the link in our bio. 🚀\n\n#saral #InfluencerMarketing #BrandCollaborations #EngageAuthentically #ModernInfluencers #ReelRevelations #podcast #htepodcast #saral #yash # brand #influncer #momentmarketing #memesdaily #funnymemes #socialmedia #agencylife  #creativespot #madovermarketing #contentmarketing #marketingdigital #marketingtips #branding #marketingmeme #marketingagency #onlinemarketing #memestagram #memetemplate',
    profile: {
      imageUrl: 'https://influencer-profile-image.s3.ap-south-1.amazonaws.com/getalmund-8qa7r.jpg',
      username: 'getalmund',
      platform: 'instagram',
      followers: 347,
    },
  },
  {
    _id: '65c0c83d2d0585ccx05447d',
    type: 'story',
    images: [
      {
        url: 'https://saral-docs-dev.s3.ap-south-1.amazonaws.com/b4511020cd81fb02aaaf9fa4a24e5101.jpeg',
      },
    ],
    video: '',
    entityUrl: 'https://instagram.com/p/C2uYJocoqz_',
    creativeCreatedDate: '2024-02-05T11:36:29.773Z',
    media: [
      {
        url: 'https://saral-docs-dev.s3.ap-south-1.amazonaws.com/b4511020cd81fb02aaaf9fa4a24e5101.jpeg',
      },
    ],
    likes: 89,
    comments: 32,
    shares: null,
    saves: null,
    impressions: 102.2,
    engagementRate: 17.416829745596868,
    contentValue: 100,
    sentiment: 'Positive',
    caption: 'Some more pics from @getsaral recent offsite trip :)',
    profile: {
      imageUrl: 'https://influencer-profile-image.s3.ap-south-1.amazonaws.com/getalmund-8qa7r.jpg',
      username: 'getalmund',
      platform: 'instagram',
      followers: 347,
    },
  },
  {
    _id: '65c1d13be1c78940f72',
    type: 'reel',
    images: '',
    video: [
      {
        url: 'https://saral-docs-dev.s3.ap-south-1.amazonaws.com/getalmund-20jtc+(1).mp4',
      },
    ],
    entityUrl: 'https://instagram.com/p/Cy-ykrbogCu',
    creativeCreatedDate: '2023-10-29T11:31:08.000Z',
    media: [
      {
        url: 'https://saral-docs-dev.s3.ap-south-1.amazonaws.com/getalmund-20jtc+(1).mp4',
      },
    ],
    likes: 8,
    comments: 2,
    shares: null,
    saves: null,
    impressions: 69.4,
    engagementRate: 2.3054755043227666,
    contentValue: 100,
    sentiment: 'Positive',
    caption:
      'Yash Chavan, CEO of Saral, a dynamic Influencer Relationship Management platform, reveals big brands are searching for a new breed of influencers who can authentically connect with their audience, drive real engagement, and embody their brand values. In this reel, let’s spill the tea ☕ on what big brands crave from influencers nowadays! 💼🌟\n\n🔍 Discover the secrets to winning brand partnerships and how to become the influencer they can’t resist! 💥💰\n\nSubscribe to our E-Commerce Newsletter for proven strategies, the latest DTC trends, and insights. Join our community of 35,000+ marketers. Click the link in our bio. 🚀\n\n#saral #InfluencerMarketing #BrandCollaborations #EngageAuthentically #ModernInfluencers #ReelRevelations #podcast #htepodcast #saral #yash # brand #influncer #momentmarketing #memesdaily #funnymemes #socialmedia #agencylife  #creativespot #madovermarketing #contentmarketing #marketingdigital #marketingtips #branding #marketingmeme #marketingagency #onlinemarketing #memestagram #memetemplate',
    profile: {
      imageUrl: 'https://influencer-profile-image.s3.ap-south-1.amazonaws.com/getalmund-8qa7r.jpg',
      username: 'getalmund',
      platform: 'instagram',
      followers: 347,
    },
  },
];

export const SocialListeningForceCollapseRoutes = [/^\/dashboard\/social\/add$/, /^\/dashboard\/social\/.*$/];
export const CustomContractsForceCollapseRoutes = [/^\/dashboard\/settings\/custom-contracts\/editor(?:\/.*)?$/];

export const isJsrStorageKey = 'is-jsr-login';
export const revenueSampleData = [
  {
    year: 2023,
    month: 'Mar',
    revenue: 1000,
  },
  {
    year: 2023,
    month: 'Apr',
    revenue: 20000,
  },
  {
    year: 2023,
    month: 'May',
    revenue: 1000,
  },
  {
    year: 2023,
    month: 'Jun',
    revenue: 5000,
  },
  {
    year: 2023,
    month: 'Jul',
    revenue: 50000,
  },
  {
    year: 2023,
    month: 'Aug',
    revenue: 10000,
  },
  {
    year: 2023,
    month: 'Sept',
    revenue: 30000,
  },
  {
    year: 2023,
    month: 'Oct',
    revenue: 20000,
  },
  {
    year: 2024,
    month: 'Jan',
    revenue: 90000,
  },
  {
    year: 2024,
    month: 'Feb',
    revenue: 60000,
  },
  {
    year: 2023,
    month: 'Nov',

    revenue: 18000,
  },
  {
    year: 2023,
    month: 'Dec',
    revenue: 5000,
  },
  {
    year: 2024,
    month: 'Mar',
    revenue: 18000,
  },
];

export const v2UserFeatures = [
  'Active Influencer Management',
  'Influencer Search Engine',
  'Unlimited Outreach',
  'Unlimited Product Shipping',
  'Post Tracking',
  'Chrome Extension',
  'Unlimited Applications',
  'Performance Reports',
  'All Integrations',
  'Priority Support',
];

export const features = [
  'List Management',
  'Email Outreach',
  'Unlimited Relationships',
  'Generate Affiliate Links',
  'Ship & Track Packages',
  'Chrome Extension',
  'Add Notes, Tasks & Reminders',
  'Manage Creator Pipeline',
  'Priority Support',
  'Accept Inbound Applications',
];

export const lite_features = [
  'Save 100 Influencers Monthly',
  'Unlimited Ongoing Relationships',
  '200 Reachouts per month',
  'Generate Affiliate Links',
  'Ship & Track Packages',
  'Chrome Extension',
  'Accept Inbound Applications',
  'Track 5 Influencer Posts',
  'Accept Inbound Applications',
];

export const lite_plan_points = [
  '200 outreaches per month',
  `Third-party affiliate integrations`,
  'One user account',
  'No social listening',
  'Fast and accessible support',
];

// quill trim word for 1 char
// so to max with our limit 250
export const WORD_LIMIT_QUILL = 349;
export const DOWNTIME_BANNER_KEY = 'multi-user-access-downtime';
export const SWITCH_ID_KEY = 'switch-ids';

export const CURRENT_TEAMMEMBER_LOGGED_KEY = 'loggedInTeamMemberId';

export const CONNECTED_ACCOUNT_FALLBACK_LIMIT = 10;

export const ASSISTANCE_NEEDED_CONTACT_LINK = DEFAULT_HUBSPOT_MEETING_LINK;

// Banner for discovery api down
export const DISCOVERY_API_DOWN_BANNER = false;

export const performanceExportMetricsData = [];

export const APP_PASSWORD_CONNECT_VIDEO_LINK = 'https://www.youtube.com/watch?v=rnT2ef4x6to';

export const OAUTH_SETUP_DOC = HELP_DESK_ARTICLES.HowToSetupGoogleOauthForSaral;
export const OAUTH_SETUP_VIDEO_LINK = 'https://fast.wistia.net/embed/iframe/j6h69469c2';
export const OAUTH_ID = '308432843578-onpa84s44va4ob4cdsiapu75kfgre867.apps.googleusercontent.com';

export const OUTLOOK_SETUP_DOC = 'https://help.getsaral.com/en/articles/334-how-to-connect-your-outlook-email-to-saral';

export const OUTLOOK_OAUTH_URL = import.meta.env.REACT_APP_OUTLOOK_OAUTH_REDIRECT_URL;

export const SUPPORT_EMAIL = 'support@getsaral.com';

export const PerformanceMetrics = [
  { label: 'Unique Visitors', value: 'uniqueVisitors' },
  { label: 'ROAS', value: 'roas' },
  { label: 'Overall ROAS', value: 'overallRoas' },
  { label: 'Revenue', value: 'revenue' },
  { label: 'Commissions', value: 'commissions' },
  { label: 'CPC', value: 'cpc' },
  { label: 'EPC', value: 'epc' },
  { label: 'Conversion Rate', value: 'conversionRate' },
  { label: 'Products Seeded', value: 'productsSeeded' },
  { label: 'Cost per Sale', value: 'costPerSale' },
  { label: 'Total Orders', value: 'totalOrders' },
  { label: 'Flat Fees', value: 'flatFees' },
  { label: 'Seeding Cost', value: 'seedingCost' },
  { label: 'Total Posts', value: 'totalPosts' },
  { label: 'Content Value', value: 'contentValue' },
];

export const InfluencerMetrics = [
  { label: 'Influencer Name', value: 'name' },
  { label: 'Username', value: 'username' },
  { label: 'Relationship Stage', value: 'stage' },
  { label: 'Address', value: 'address' },
  {
    label: 'Instagram Link',
    value: 'instagram_link',
  },
  {
    label: 'Youtube Link',
    value: 'youtube_link',
  },
  {
    label: 'Tiktok Link',
    value: 'tiktok_link',
  },
  {
    label: 'Total Followers',
    value: 'followers',
  },
  {
    label: 'Discount Codes',
    value: 'discountCodes',
  },
  {
    label: 'Commission Tier',
    value: 'commissionTier',
  },
  {
    label: 'Affiliate Links',
    value: 'affiliateLinks',
  },
  {
    label: 'Lists',
    value: 'lists',
  },
  {
    label: 'Onboarding Date',
    value: 'onboardingDate',
  },
  {
    label: 'Engagement Rate',
    value: 'engagementRate',
  },
];

export const PaymentMetrics = [
  { label: 'Paypal Email', value: 'paypalEmail' },
  {
    label: 'Total Payments Made',
    value: 'totalPaymentsMade',
  },
  {
    label: 'Pending Commissions',
    value: 'pendingCommissions',
  },
];

export const AllMetricsTabs = [
  {
    label: 'Performance Metrics',
    value: 'performance',
  },
  {
    label: 'Influencer Details',
    value: 'influencer',
  },
  {
    label: 'Payment Details',
    value: 'payment',
  },
];

export const DISCOUNT_CODE_INBOUND_TEMPLATE = "Here's a discount code for your fans: {{discount_code}}";
export const CT_LINK_INBOUND_TEMPLATE = "Here's your affiliate link: {{tracking_link}}";

export const __DEV__ = import.meta.env.REACT_APP_SARAL_ENV === 'dev';
export const __DEV_APP__ = import.meta.env.REACT_APP_DOMAIN === 'https://dev-app.getsaral.com';
export const __PROD__ = import.meta.env.REACT_APP_SARAL_ENV === 'prod';
export const POSTHOG_KEY = 'phc_iuEvzb7oTNhsqRIMPUPYg5YKI19zfcenRNh0pMR1l85';

export const AMBASSADOR_QUESTIONS = [
  {
    question: 'How many followers do you have? ',
    isActive: true,
    questionType: 'singleLineAnswer',
    isRequired: true,
    translateKey: '',
  },
  {
    question: 'Why do you want to become an ambassador for {{BRAND}}?',
    isActive: true,
    questionType: 'longAnswer',
    isRequired: true,
    translateKey: '',
  },
  {
    question: 'Have you tried our products? If so, which one is your favorite and why?',
    isActive: true,
    questionType: 'longAnswer',
    isRequired: true,
    translateKey: '',
  },
  {
    question: 'How do you intend to promote these products?',
    isActive: true,
    questionType: 'longAnswer',
    isRequired: true,
    translateKey: '',
  },
];

export const CREATOR_PAGE_DOMAIN = import.meta.env.REACT_APP_CREATOR_PAGE_DOMAIN;
export const ACTIVATION_EMAIL_DELAY_OPTIONS = [
  { label: '1 hour', value: '1 hour' },
  { label: '3 hours', value: '3 hours' },
  { label: '8 hours', value: '8 hours' },
  { label: '1 day', value: '1 day' },
  { label: '3 days', value: '3 days' },
  { label: '7 days', value: '7 days' },
  { label: '14 days', value: '14 days' },
  { label: '1 month', value: '1 month' },
];

export const ACTIVATION_EMAIL_TRIGGER_FREQUENCY_OPTIONS = [
  { label: 'Send Once', value: 'send_once' },
  { label: 'Send Always', value: 'send_always' },
];

export const ENABLED_OPTIONS_FOR_ACTIVATION_EMAIL_FREQUENCY = [
  'linkPlusCode',
  'productShipped',
  'productDelivered',
  'linkOnly',
];

export const ENABLE_OAUTH_EMAILS = ['yash@getsaral.com', 'shubh@getsaral.com', 'raunak+dev@getsaral.com'];

export const INBOUND_FORM_APPROVAL_PREFERENCES = APPLICATION_FORM_APPROVAL_PREFERENCES;

export const SHOW_FACEBOOK_LOGIN_ACCOUNT = ['shubh+facebook@getsaral.com'];

export const PERFORMANCE_EXPORT_PREFERENCES = [
  {
    label: 'By Influencer',
    value: 'influencer',
    tooltip: 'Export metrics cumulative by Influencer',
  },
  {
    label: 'By Date',
    value: 'date',
    tooltip: 'Export metrics by date',
  },
];

export const SHORT_URL_PREFIX = 'https://gtsrl.io';

export const REGISTER_ALLOWED_EMAILS = [
  'tech@getsaral.com',
  'yash@getsaral.com',
  'jim.t@getsaral.com',
  'mike@getsaral.com',
];
export const getTemplateContent = (templateId) => {
  const templates = {
    [contractTemplateType.PAY_PER_POST]: {
      scopeOfContent:
        'The Influencer will create and deliver a total of <span class="ql-special" style="color: rgba(127, 17, 224, 1);" data-special="N">N</span> assets as a part of this contract.<div><br/></div><p><span class="ql-special" style="color: rgba(127, 17, 224, 1);" data-special="CONTENT_TYPE">CONTENT_TYPE</span> will be posted <span class="ql-special" style="color: rgba(127, 17, 224, 1);" data-special="N">N</span> times on <span class="ql-special" style="color: rgba(127, 17, 224, 1);" data-special="PLATFORM">PLATFORM</span> with hashtag <span class="ql-special" style="color: rgba(127, 17, 224, 1);" data-special="#TAG">#TAG</span> and with a tag to <span class="ql-special" style="color: rgba(127, 17, 224, 1);" data-special="@BRAND">@BRAND</span></p><div><br/></div><div>Each video should be 60-90 sec long and must follow the guidelines shared separately with the Influencer. They will be posted on <span class="ql-special" style="color: rgba(127, 17, 224, 1);" data-special="PLATFORM">PLATFORM</span> on the days/times separately agreed upon by both parties.</div>',
      paymentTerms:
        'A flat fee of <span class="ql-special" style="color: rgba(127, 17, 224, 1);" data-special="$AMOUNT">$AMOUNT</span> paid 50% upon signing and 50% upon successful delivery of the content as per Scope of Content outlined above.<div><br></div><div>The compensation amount will be sent through a mutually agreed upon payment method between the Company and Influencer, such as PayPal, Venmo, or Bank Transfer.</div>',
    },
    [contractTemplateType.BASE_PLUS_BONUS]: {
      scopeOfContent:
        'The Influencer will create and deliver a total of <span class="ql-special" style="color: rgba(127, 17, 224, 1);" data-special="N">N</span> assets as a part of this contract.<div><br/></div><p><span class="ql-special" style="color: rgba(127, 17, 224, 1);" data-special="CONTENT_TYPE">CONTENT_TYPE</span> will be posted <span class="ql-special" style="color: rgba(127, 17, 224, 1);" data-special="N">N</span> times on <span class="ql-special" style="color: rgba(127, 17, 224, 1);" data-special="PLATFORM">PLATFORM</span> with hashtag <span class="ql-special" style="color: rgba(127, 17, 224, 1);" data-special="#TAG">#TAG</span> and with a tag to <span class="ql-special" style="color: rgba(127, 17, 224, 1);" data-special="@BRAND">@BRAND</span></p><div><br/></div><div>Each video should be 60-90 sec long and must follow the guidelines shared separately with the Influencer. They will be posted on <span class="ql-special" style="color: rgba(127, 17, 224, 1);" data-special="PLATFORM">PLATFORM</span> on the days/times separately agreed upon by both parties.</div>',
      paymentTerms:
        'A flat fee of <span class="ql-special" style="color: rgba(127, 17, 224, 1);" data-special="$AMOUNT">$AMOUNT</span> paid 50% upon signing and 50% upon successful delivery of the content as per Scope of Content outlined above.<div><br></div><div>A commission of <span class="ql-special" style="color: rgba(127, 17, 224, 1);" data-special="PERCENTAGE%">PERCENTAGE%</span> on any sales generated by the Influencer\'s promotion of the Company\'s products or services. Sales will be attributed via affiliate links and/or coupon codes.</div><div><br></div><div>Commissions for the previous month will be sent on or before the 5th of next month.</div><div><br></div>The total compensation amount will be sent through a mutually agreed upon payment method between the Company and influencer, such as Paypal, Venmo, or Bank Transfer.',
    },
    [contractTemplateType.GIFTING_SEEDING]: {
      scopeOfContent:
        'Influencer will receive One (1) free product <span class="ql-special" style="color: rgba(127, 17, 224, 1);" data-special="PRODUCT_NAME">PRODUCT_NAME</span> from Company.<div><br></div><div>Company would appreciate if Influencer promotes the product at least 3 times on their <span class="ql-special" style="color: rgba(127, 17, 224, 1);" data-special="PLATFORM">PLATFORM</span> with the hashtag <span class="ql-special" style="color: rgba(127, 17, 224, 1);" data-special="#TAG">#TAG</span> and with a tag to <span class="ql-special" style="color: rgba(127, 17, 224, 1);" data-special="@BRAND">@BRAND</span>.</div><div><br></div><div>Content type can be a short form story, or a longer format video (reel, story series).</div>',
      paymentTerms:
        'This is a collaboration where compensation is made in kind i.e. with a free product from Company to Influencer. There is no additional payment.',
    },
    [contractTemplateType.AMBASSADOR_AFFILIATE]: {
      scopeOfContent:
        'Influencer agrees to become a social media ambassador affiliate for Company.<div><br></div><div>Company would appreciate if Influencer promotes the product at least 2 times each month on their <span class="ql-special" style="color: rgba(127, 17, 224, 1);" data-special="PLATFORM">PLATFORM</span> with the hashtag <span class="ql-special" style="color: rgba(127, 17, 224, 1);" data-special="#TAG">#TAG</span> and with a tag to <span class="ql-special" style="color: rgba(127, 17, 224, 1);" data-special="@BRAND">@BRAND</span>.</div><div><br></div><div>Company gives full creative freedom to its ambassador to make any type and format of content they want. Company may share guidelines and inspiration separately to enable the Influencer to create high-performing content.</div>',
      paymentTerms:
        'As an ambassador of Company, the Influencer will receive free products from the company as rewards for posts and sales milestones.<div><br></div><div>A commission of <span class="ql-special" style="color: rgba(127, 17, 224, 1);" data-special="PERCENTAGE%">PERCENTAGE%</span> on any sales generated by the Influencer\'s promotion of the Company\'s products or services. Sales will be attributed via affiliate links and/or coupon codes.</div><div><br></div><div>Commissions for the previous month will be sent on or before the 5th of next month.</div><div><br></div>The total compensation amount will be sent through a mutually agreed upon payment method between the Company and Influencer, such as PayPal, Venmo, or Bank Transfer.',
    },
    [contractTemplateType.UGC]: {
      scopeOfContent:
        'The Influencer will create and deliver a total of <span class="ql-special" style="color: rgba(127, 17, 224, 1);" data-special="N">N</span> videos as part of this contract.<div><br></div><div>Each video should be 60-90 sec long and must follow the guidelines shared separately with the Influencer.</div><div><br></div><div>The Company reserves the right to request revisions or modifications to the content, and the Influencer agrees to make reasonable efforts to accommodate such requests.</div><div><br></div>The Influencer shall submit the first piece of content to Company by <span class="ql-special" style="color: rgba(127, 17, 224, 1);" data-special="DUE_DATE">DUE_DATE</span>, second content by <span class="ql-special" style="color: rgba(127, 17, 224, 1);" data-special="DUE_DATE">DUE_DATE</span>, and third content by <span class="ql-special" style="color: rgba(127, 17, 224, 1);" data-special="DUE_DATE">DUE_DATE</span>.',
      paymentTerms:
        'A flat fee of <span class="ql-special" style="color: rgba(127, 17, 224, 1);" data-special="$AMOUNT">$AMOUNT</span> paid 50% upon signing and 50% upon successful delivery of the content as per Scope of Content outlined above.<div><br></div><div>The compensation amount will be sent through a mutually agreed upon payment method between the Company and Influencer, such as PayPal, Venmo, or Bank Transfer.</div>',
    },
    [contractTemplateType.WHITELISTING]: {
      scopeOfContent:
        'The Influencer will create and deliver a total of <span class="ql-special" style="color: rgba(127, 17, 224, 1);" data-special="N">N</span> videos as part of this contract.<div><br></div><div>Each video should be 60-90 sec long and must follow the guidelines shared separately with the Influencer. They will be posted on <span class="ql-special" style="color: rgba(127, 17, 224, 1);" data-special="PLATFORM">PLATFORM</span> on the days/times separately agreed upon by both parties.</div><div><br></div><div>The Company reserves the right to request revisions or modifications to the content, and the Influencer agrees to make reasonable efforts to accommodate such requests.</div><div><br></div><div>The Influencer shall submit all the deliverables on or before <span class="ql-special" style="color: rgba(127, 17, 224, 1);" data-special="DUE_DATE">DUE_DATE</span>.</div><div><br/></div><div>This scope and payment terms also cover whitelisting access. The Influencer agrees to provide the Company with whitelisting access to their social media ad accounts on <span class="ql-special" style="color: rgba(127, 17, 224, 1);" data-special="SPECIFIED_PLATFORMS">SPECIFIED_PLATFORMS</span>, allowing the Brand to run ads using the Influencer\'s content and profile.</div><div><br/></div><div>The Company will have access to create, manage, and optimize ads using the Influencer&apos;s account for a period of <span class="ql-special" style="color: rgba(127, 17, 224, 1);" data-special="DURATION">DURATION</span>.</div><div><br/></div><div>The Company agrees to use the whitelisting access solely for the promotion of the agreed content and will not use the access for any other purpose.</div>',
      paymentTerms:
        'A flat fee of <span class="ql-special" style="color: rgba(127, 17, 224, 1);" data-special="$AMOUNT">$AMOUNT</span> paid 50% upon signing and 50% upon successful delivery of the content as per Scope of Content outlined above.<div><br/></div><div>The compensation amount will be sent through a mutually agreed upon payment method between the Company and Influencer, such as PayPal, Venmo, or Bank Transfer.</div>',
    },
  };

  return templates[templateId];
};

export const triggerTypesOptions = [
  { label: 'Change Once', value: 'once' },
  { label: 'Change Always', value: 'always' },
];

export const getRVBoardCacheKey = (userId) => {
  if (!userId) {
    return null;
  }
  const cacheKey = `rv_board_${userId}`;
  return cacheKey;
};

export const COMPULSORY_LINKS = ['Primary Username', 'Instagram Link', 'YouTube Link', 'TikTok Link'];

// Dialog Constants
export const SAVING_DIALOG_DELAY = 3000; // 3 seconds delay before closing
export const COMPLETION_ANIMATION_DELAY = 500; // Time to show 100% before closing
